import React from 'react';
import { VMManagement } from '../../components/Admin/VMManagement';

const VMManagementPage: React.FC = () => {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">VM Management</h1>
        <p className="text-gray-600 mt-2">
          Control and monitor the Refinitiv data fetcher virtual machine
        </p>
      </div>
      
      <VMManagement />
    </div>
  );
};

export default VMManagementPage;
